// extracted by mini-css-extract-plugin
export default {"main":"CatalogGenrePage_main__NmR8r","header":"CatalogGenrePage_header__+ovIC","title_block":"CatalogGenrePage_title_block__PpN3U"};